import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=bf1681ae&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf1681ae')) {
      api.createRecord('bf1681ae', component.options)
    } else {
      api.reload('bf1681ae', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=bf1681ae&", function () {
      api.rerender('bf1681ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile.vue"
export default component.exports